import { render, staticRenderFns } from "./CMvContentLogo.vue?vue&type=template&id=20c03679&"
import script from "./CMvContentLogo.vue?vue&type=script&lang=ts&"
export * from "./CMvContentLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports